import { render, staticRenderFns } from "./PluckSharing.vue?vue&type=template&id=582fef29&scoped=true"
import script from "./PluckSharing.vue?vue&type=script&lang=js"
export * from "./PluckSharing.vue?vue&type=script&lang=js"
import style0 from "./PluckSharing.vue?vue&type=style&index=0&id=582fef29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582fef29",
  null
  
)

export default component.exports